import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
	selector: 'workflow-missing-value-modal',
	templateUrl: './missing-value-modal.component.html',
	styleUrls: []
})
export class MissingValueModalComponent {

	@Input() showMissingValueModal: boolean;
	@Output() showMissingValueModalChange: EventEmitter<boolean> = new EventEmitter();

	@Output() clickOk: EventEmitter<boolean> = new EventEmitter();

	closeMissingValueModal(): void {
		this.showMissingValueModal = false;
		this.showMissingValueModalChange.emit(false);
	}

	emitOK(): void {
		this.clickOk.emit(true);
	}
}
